// @ts-nocheck

import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import ToggleStats from '../toggle-stats'

import { Card, CardText } from 'material-ui/Card'
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table'
import { setSnackbarMessage } from '../../../actions/snackbar'

import Spacer from '../../spacer'
import api from '../../../api'
import moment from 'moment'
import { find } from 'lodash'
import { styles } from './styles'

const formatDate = date => moment(date).format('MMM D, YYYY')

const getMetricData = (metrics = [], name) => {
  const metric = find(metrics, { name })
  return metric ? metric.data : []
}

const titleCase = (str) => {
  let i
  const frags = str.split('_')
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
  }
  return frags.join(' ')
}

const sections = [
  { value: 'general', name: 'General' },
  { value: 'title_breakdown', name: 'Title Breakdown' },
  { value: 'gender_breakdown', name: 'Gender Breakdown' },
  { value: 'ethnicity_breakdown', name: 'Ethnicity Breakdown' },
  { value: 'session_reservations', name: 'Session Reservations' }
]

class InstitutionAnalytics extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      loaded: false
    }
  }

  componentWillMount () {
    this.loadData()
      .then(() => {
        this.setState({ loaded: true })
      })
  }

  loadData () {
    return api.get(`stats/institutions/${this.props.params.institutionId}`)
      .then(res => res.json())
      .then(data => {
        this.setState({ data })
      })
  }

  toggleHandler = (toggle, stateKey) => {
    this.state.data.display_config[stateKey] = !this.state.data.display_config[stateKey]

    const body = {
      metrics_display_config: {
        general: this.state.data.display_config.general,
        title_breakdown: this.state.data.display_config.title_breakdown,
        gender_breakdown: this.state.data.display_config.gender_breakdown,
        ethnicity_breakdown: this.state.data.display_config.ethnicity_breakdown,
        session_reservations: this.state.data.display_config.session_reservations
      }
    }

    api
      .patch(`admin/institutions/${this.props.params.institutionId}/?with_deleted=true`, { body })
      .then(res => res.json()).then(() => this.setState(this.state))

    this.props.setSnackbarMessage(`${find(sections, { value: stateKey }).name} section has been ${this.state.data.display_config[stateKey] ? 'enabled' : 'disabled'}.`)
  }

  render () {
    if (!this.state.loaded) return null
    const { metrics, institution_membership: institutionMembership } = this.state.data

    const cumulativeDailyLogins = getMetricData(metrics, 'cumulative_daily_logins')
    const subaccountData = getMetricData(metrics, 'sub_accounts')
    const sessionReservations = getMetricData(metrics, 'session_reservations')
    const titleBreakdownData = getMetricData(metrics, 'title_breakdown')
    const genderBreakdownData = getMetricData(metrics, 'gender_breakdown')
    const ethnicityBreakdownData = getMetricData(metrics, 'ethnicity_breakdown')

    return (
      <div>
        <div style={styles.title}>
          Analytics
        </div>
        <span style={styles.statsHeading}>General</span>
        <ToggleStats
          label='Show to Institution member' value={this.state.data.display_config.general}
          onChange={(toggle) => { this.toggleHandler(toggle, 'general') }}
        />

        <div style={styles.cardContainer}>
          <Card style={styles.card}>
            <CardText>
              <div style={styles.statTitle}>Institutional Subaccounts</div>
              <Spacer />
              <div>
                <span style={styles.description}>Institutional Membership</span>
                {formatDate(institutionMembership.activated_at)}
              </div>
              <Spacer />
              <div>
                <span style={styles.description}>Member expiry date</span>
                {formatDate(institutionMembership.expires_at)}
              </div>
            </CardText>
          </Card>
          <Card style={styles.card}>
            <CardText>
              <div style={styles.statTitle}>Institutional Subaccounts</div>
              <div style={styles.statValue}>{subaccountData.length ? subaccountData[0].value : null}</div>
            </CardText>
          </Card>
          <Card style={styles.card}>
            <CardText>
              <div style={styles.statTitle}>Total Active Sessions</div>
              <div
                style={styles.statValue}
              >{cumulativeDailyLogins.length ? cumulativeDailyLogins[0].value : null}
              </div>
            </CardText>
          </Card>
        </div>

        <Spacer />
        <span style={styles.statsHeading}>Session Reservations</span>
        <ToggleStats
          label='Show to Institution member' value={this.state.data.display_config.session_reservations}
          onChange={(toggle) => { this.toggleHandler(toggle, 'session_reservations') }}
        />

        <div style={styles.cardContainer}>
          <Card style={styles.card}>
            <CardText>
              <div style={styles.statTitle}>FSP Registrations</div>
              <div style={styles.statValue}>{sessionReservations.length ? sessionReservations[0].value : null}</div>
            </CardText>
          </Card>
          <Card style={styles.card}>
            <CardText>
              <div style={styles.statTitle}>Alumni Registrations</div>
              <div style={styles.statValue}>{sessionReservations.length ? sessionReservations[1].value : null}</div>
            </CardText>
          </Card>
          <Card style={styles.card}>
            <CardText>
              <div style={styles.statTitle}>14-Day Writing Challenge Registrations</div>
              <div style={styles.statValue}>{sessionReservations.length ? sessionReservations[2].value : null}</div>
            </CardText>
          </Card>
          <Card style={styles.card}>
            <CardText>
              <div style={styles.statTitle}>14-Day Writing Challenge Registrations</div>
              <div style={styles.statValue}>{sessionReservations.length ? sessionReservations[5].value : null}</div>
            </CardText>
          </Card>
        </div>

        <Spacer />
        <span style={styles.statsHeading}>Title Breakdown</span>
        <ToggleStats label='Show to Institution member' value={this.state.data.display_config.title_breakdown} onChange={(toggle) => { this.toggleHandler(toggle, 'title_breakdown') }} />

        <div style={styles.cardContainer}>
          <Card>
            <CardText>
              <Table style={styles.table} selectable={false}>
                <TableBody displayRowCheckbox={false}>
                  <TableRow>
                    <TableRowColumn>
                  Title
                    </TableRowColumn>
                    <TableRowColumn style={styles.tableRowColumn}>
                  Number of Users
                    </TableRowColumn>
                  </TableRow>
                  {titleBreakdownData.map(item => {
                    return (
                      <TableRow key={item.name}>
                        <TableRowColumn>{titleCase(item.name || 'Unspecified')}</TableRowColumn>
                        <TableRowColumn style={styles.tableRowColumn}>{item.value}</TableRowColumn>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </CardText>
          </Card>
        </div>

        <Spacer />
        <span style={styles.statsHeading}>Gender Breakdown</span>
        <ToggleStats label='Show to Institution member' value={this.state.data.display_config.gender_breakdown} onChange={(toggle) => { this.toggleHandler(toggle, 'gender_breakdown') }} />

        <div style={styles.cardContainer}>
          <Card>
            <CardText>
              <Table style={styles.table} selectable={false}>
                <TableBody displayRowCheckbox={false}>
                  <TableRow>
                    <TableRowColumn>
                  Title
                    </TableRowColumn>
                    <TableRowColumn style={styles.tableRowColumn}>
                  Number of Users
                    </TableRowColumn>
                  </TableRow>
                  {genderBreakdownData.map(item => {
                    return (
                      <TableRow key={item.name}>
                        <TableRowColumn>{titleCase(item.name || 'Unspecified')}</TableRowColumn>
                        <TableRowColumn style={styles.tableRowColumn}>{item.value}</TableRowColumn>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </CardText>
          </Card>
        </div>

        <Spacer />
        <span style={styles.statsHeading}>Ethnicity Breakdown</span>
        <ToggleStats label='Show to Institution member' value={this.state.data.display_config.ethnicity_breakdown} onChange={(toggle) => { this.toggleHandler(toggle, 'ethnicity_breakdown') }} />

        <div style={styles.cardContainer}>
          <Card>
            <CardText>
              <Table style={styles.table} selectable={false}>
                <TableBody displayRowCheckbox={false}>
                  <TableRow>
                    <TableRowColumn>
                  Title
                    </TableRowColumn>
                    <TableRowColumn style={styles.tableRowColumn}>
                  Number of Users
                    </TableRowColumn>
                  </TableRow>
                  {
                    ethnicityBreakdownData.map(item => {
                      return (
                        <TableRow key={item.name}>
                          <TableRowColumn>{titleCase(item.name || 'Unspecified')}</TableRowColumn>
                          <TableRowColumn style={styles.tableRowColumn}>{item.value}</TableRowColumn>
                        </TableRow>
                      )
                    })
                  }
                </TableBody>
              </Table>
            </CardText>
          </Card>
        </div>
      </div>
    )
  }
}

// @ts-ignore
InstitutionAnalytics.propTypes = {
  setSnackbarMessage: PropTypes.func.isRequired
}

export default connect(null, { setSnackbarMessage })(InstitutionAnalytics)
